import { h } from 'preact';
import { useI18n } from 'src/hooks/i18n';

// eslint-disable-next-line no-shadow
export const I18nHOC = () => Component => function ComponentI18nHOC (props) {
    const I18nContext = useI18n();
    return <Component {...I18nContext} {...props} />;
};